module.exports = "<div id=\"map\"></div>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/maps/maps.component.html
// module id = 484
// module chunks = 1